<ng-template #filtersMobile>
  <div class="search-engine-filters-modal__header">
    <h2 role="heading" class="search-engine-filters-modal__header__text">
      Filtres <mat-icon svgIcon="filter" aria-label="Filtre"></mat-icon>
    </h2>
    <mat-icon
      class="search-engine-filters-modal__header__icon"
      svgIcon="close"
      aria-label="Fermer"
      (click)="closeFiltersModal()"
    ></mat-icon>
  </div>
  <div class="search-engine-filters-modal__content">
    <form *ngIf="searchForm" [formGroup]="searchForm" (submit)="onSubmit()">
      <ng-container *ngTemplateOutlet="formSubmainFilters"></ng-container>
      <ng-container *ngTemplateOutlet="formAdvancedFilters"></ng-container>

      <button class="btn-clean search-engine-filters-modal__apply-btn" (click)="closeFiltersModal()" type="submit">
        Appliquer
        <mat-icon svgIcon="arrow_next" role="presentation"></mat-icon>
      </button>
    </form>
  </div>
</ng-template>

<ng-container
  *ngIf="
    ((isMobileOrTablet$ | async) === true && !fields.mainField.required) || (isMobileOrTablet$ | async) === false;
    else filtersMobileRequired
  "
>
  <form
    *ngIf="searchForm"
    [formGroup]="searchForm"
    (submit)="onSubmit()"
    class="search-container"
    [class.search-container--collapse]="(advancedFiltersIsOpen$ | async) === false"
    [class.search-container--expand]="(advancedFiltersIsOpen$ | async) === true"
    [class.search-container--error]="(formErrors$ | async)?.length > 0"
  >
    <div class="search-engine" [class.search-engine--mobile]="(isMobileOrTablet$ | async) === true">
      <div
        class="search-engine__element"
        [style.flex]="fields.mainField.flexValue"
        [class.search-engine__element--borderless]="fields.submainFields.length === 0"
      >
        <app-location-search-eures
          *ngIf="fields.mainField.type === SearchEngineFieldType.LocationEures"
          formControlName="location"
          [field]="fields.mainField | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search-eures>
        <app-location-search-pole-emploi
          *ngIf="fields.mainField.type === SearchEngineFieldType.LocationPoleEmploi"
          formControlName="location"
          [field]="fields.mainField | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search-pole-emploi>
        <app-location-search
          *ngIf="fields.mainField.type === SearchEngineFieldType.Location"
          formControlName="location"
          [liveSearch]="fields.liveSearch"
          [field]="fields.mainField | castToSpecificFieldType"
          [modalOpen]="displayAsOpenedModal$ | async"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search>
        <app-address-search
          *ngIf="fields.mainField.type === SearchEngineFieldType.Address"
          formControlName="address"
          [liveSearch]="fields.liveSearch"
          [field]="fields.mainField | castToSpecificFieldType"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-address-search>
        <app-text-input-search
          *ngIf="fields.mainField.type === SearchEngineFieldType.TextInput"
          [formControlName]="fields.mainField.name"
          [liveSearch]="fields.liveSearch"
          [field]="fields.mainField | castToSpecificFieldType"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-text-input-search>
        <app-romes-input-search
          *ngIf="fields.mainField.type === SearchEngineFieldType.RomesInput"
          [formControlName]="fields.mainField.name"
          [liveSearch]="fields.liveSearch"
          [field]="fields.mainField | castToSpecificFieldType"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-romes-input-search>
        <app-text-romes-input-search
          *ngIf="fields.mainField.type === SearchEngineFieldType.TextRomesInput"
          [formControlName]="fields.mainField.name"
          [liveSearch]="fields.liveSearch"
          [field]="fields.mainField | castToSpecificFieldType"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        >
        </app-text-romes-input-search>
      </div>

      <ng-container *ngIf="(isMobileOrTablet$ | async) === true; else formSubmainFilters"></ng-container>

      <button
        type="button"
        [attr.aria-expanded]="advancedFiltersIsOpen$ | async"
        [attr.aria-controls]="elm_id"
        aria-label="Bouton pour ouvrir les filtres avancés"
        class="btn-clean advanced-search-container__btn"
        (click)="clickAdvancedFilters()"
        *ngIf="(isMobileOrTablet$ | async) === false && fields?.advancedFields?.length > 0"
      >
        Filtrer<ng-container *ngIf="(nbAdvancedFilters$ | async) > 0"> ({{ nbAdvancedFilters$ | async }})</ng-container>
      </button>
      <button
        *ngIf="!fields.liveSearch && (isMobileOrTablet$ | async) === false"
        type="submit"
        class="search-engine__button btn-clean btn"
        (click)="trackFilterAndSearchButton()"
      >
        Rechercher
        <mat-icon class="search-engine__button--icon" matSuffix svgIcon="arrow_next" role="presentation"></mat-icon>
      </button>
      <button
        *ngIf="(isMobileOrTablet$ | async) === true && (!fields.liveSearch || fields.submainFields.length > 0)"
        type="button"
        class="search-engine__button btn-clean btn search-engine__button--mobile"
        (click)="trackFilterAndSearchButton()"
      >
        <mat-icon
          class="search-engine__button--icon-mobile"
          matSuffix
          svgIcon="filter"
          (click)="openFiltersModal()"
          role="presentation"
        ></mat-icon>
      </button>
      <mat-error
        *ngFor="let formError of formErrors$ | async; trackBy: trackByString"
        class="search-container__error-message"
      >
        {{ formError }}
      </mat-error>
    </div>
    <div
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      appPressEscapeKey
      (pressEscapeKey)="closeAdvancedFilters()"
      [id]="elm_id"
      class="advanced-search-container"
      [@advancedFiltersOnEnterLeave]
      *ngIf="
        (isMobileOrTablet$ | async) === false && fields?.advancedFields?.length > 0 && advancedFiltersIsOpen$ | async
      "
    >
      <ng-container *ngTemplateOutlet="formAdvancedFilters"></ng-container>
    </div>
  </form>
</ng-container>

<ng-template #filtersMobileRequired>
  <form
    *ngIf="searchForm"
    [formGroup]="searchForm"
    (submit)="onSubmit()"
    class="search-container search-engine-mobile-required"
    [class.search-container--error]="fields.mainField.required && (formErrors$ | async)?.length > 0"
  >
    <div class="search-engine-mobile-required__field" [style.flex]="fields.mainField.flexValue">
      <app-location-search-eures
        *ngIf="fields.mainField.type === SearchEngineFieldType.LocationEures"
        formControlName="location"
        [field]="fields.mainField | castToSpecificFieldType"
        [liveSearch]="fields.liveSearch"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-location-search-eures>
      <app-location-search-pole-emploi
        *ngIf="fields.mainField.type === SearchEngineFieldType.LocationPoleEmploi"
        formControlName="location"
        [field]="fields.mainField | castToSpecificFieldType"
        [liveSearch]="fields.liveSearch"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-location-search-pole-emploi>
      <app-location-search
        *ngIf="fields.mainField.type === SearchEngineFieldType.Location"
        formControlName="location"
        [liveSearch]="fields.liveSearch"
        [field]="fields.mainField | castToSpecificFieldType"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-location-search>
      <app-text-input-search
        *ngIf="fields.mainField.type === SearchEngineFieldType.TextInput"
        [formControlName]="fields.mainField.name"
        [liveSearch]="fields.liveSearch"
        [field]="fields.mainField | castToSpecificFieldType"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-text-input-search>
      <app-romes-input-search
        *ngIf="fields.mainField.type === SearchEngineFieldType.RomesInput"
        [formControlName]="fields.mainField.name"
        [liveSearch]="fields.liveSearch"
        [field]="fields.mainField | castToSpecificFieldType"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-romes-input-search>
      <app-address-search
        *ngIf="fields.mainField.type === SearchEngineFieldType.Address"
        formControlName="address"
        [liveSearch]="fields.liveSearch"
        [field]="fields.mainField | castToSpecificFieldType"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-address-search>
    </div>

    <ng-container *ngTemplateOutlet="formSubmainFilters"></ng-container>

    <button class="btn-clean search-engine-mobile-required__search-btn" type="submit">
      Rechercher
      <mat-icon svgIcon="arrow_next" role="presentation"></mat-icon>
    </button>
  </form>

  <mat-error
    *ngFor="let formError of formErrors$ | async; trackBy: trackByString"
    class="search-container__error-message"
  >
    {{ formError }}
  </mat-error>
</ng-template>

<ng-template #formSubmainFilters>
  <ng-container [formGroup]="searchForm">
    <ng-container *ngFor="let field of fields.submainFields; let last = last; trackBy: trackBySearchEngineField">
      <div
        *ngIf="field.type === SearchEngineFieldType.Location"
        class="search-engine__element engine__element__city"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--modal--input]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-location-search
          formControlName="location"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          [style.flex]="field.flexValue"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.LocationPoleEmploi"
        class="search-engine__element engine__element__city"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-location-search-pole-emploi
          formControlName="location"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          [style.flex]="field.flexValue"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search-pole-emploi>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.LocationEures"
        class="search-engine__element engine__element__city"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-location-search-eures
          formControlName="location"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-location-search-eures>
      </div>

      <div
        *ngIf="field.type === SearchEngineFieldType.Select"
        class="search-engine__element"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-select-search
          [formControlName]="field.name"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          [isInMainFields]="true"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-select-search>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.DurationSelect"
        class="search-engine__element"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [class.search-engine-mobile-required__field]="(isMobileOrTablet$ | async) === true && field.required"
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-select-duration-pole-emploi
          [formControlName]="field.name"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          [isInMainFields]="true"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-select-duration-pole-emploi>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.Checkbox"
        class="search-engine__element engine__element__city"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [class.search-engine-mobile-required__field]="(isMobileOrTablet$ | async) === true && field.required"
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <app-checkbox-search
          [formControlName]="field.name"
          [field]="field | castToSpecificFieldType"
          [liveSearch]="fields.liveSearch"
          [modalOpen]="displayAsOpenedModal$ | async"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        ></app-checkbox-search>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.Dropdown"
        class="search-engine__element"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        [class.search-engine__element--last]="last"
        [class.search-engine-mobile-required__field]="(isMobileOrTablet$ | async) === true && field.required"
        [style.flex]="field.flexValue"
        appDropdownPanel
      >
        <mat-icon
          *ngIf="(displayAsOpenedModal$ | async) === false"
          class="search-engine__icon"
          matSuffix
          role="presentation"
          [svgIcon]="field.icon"
        ></mat-icon>

        <app-dropdown
          [formControlName]="field.name"
          [label]="field.placeholder"
          [ariaLabel]="field.ariaLabel"
          class="dropdown-contracts dropdown--filter"
          [liveSearch]="fields.liveSearch"
          [multiple]="true"
          [options]="(field | castToSpecificFieldType)?.value"
          [required]="false"
          (panelTriggered)="updateDropdownPanelState(field, $event)"
          [doubleColumn]="
            (isMobileOrTablet$ | async) === false ? (field | castToSpecificFieldType)?.doubleColumn : false
          "
          (valueUpdated)="fieldHasChanged(fields.liveSearch)"
          [orderByAscd]="(field | castToSpecificFieldType)?.orderByAscd"
        ></app-dropdown>
      </div>
      <div
        *ngIf="field.type === SearchEngineFieldType.WeeklyDurationSelect"
        class="search-engine__element engine__element__city"
        [style.flex]="field.flexValue"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        [class.search-engine__element--modal--input]="displayAsOpenedModal$ | async"
        [class.search-engine__element--borderless]="
          (isMobileOrTablet$ | async) === false && !fields?.advancedFields?.length && last
        "
        appDropdownPanel
      >
        <app-select-weekly-duration
          [field]="field | castToSpecificFieldType"
          [formControlName]="field.name"
        ></app-select-weekly-duration>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #formAdvancedFilters>
  <ng-container [formGroup]="searchForm">
    <ng-container *ngFor="let field of fields.advancedFields; trackBy: trackBySearchEngineField">
      <app-select-search
        *ngIf="field.type === SearchEngineFieldType.Select"
        [formControlName]="field.name"
        [field]="field | castToSpecificFieldType"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
        (isPanelOpen)="toggleCanAdvancedFiltersClose($event)"
      ></app-select-search>
      <app-select-duration-pole-emploi
        class="advanced-search-container__element"
        *ngIf="field.type === SearchEngineFieldType.DurationSelect"
        [formControlName]="field.name"
        [field]="field | castToSpecificFieldType"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
        (isPanelOpen)="toggleCanAdvancedFiltersClose($event)"
      ></app-select-duration-pole-emploi>
      <app-checkbox-search
        *ngIf="field.type === SearchEngineFieldType.Checkbox"
        [formControlName]="field.name"
        [field]="field | castToSpecificFieldType"
        [modalOpen]="displayAsOpenedModal$ | async"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
      ></app-checkbox-search>
      <div
        *ngIf="field.type === SearchEngineFieldType.Dropdown"
        class="advanced-search-container__element"
        [class.search-engine__element--modal]="displayAsOpenedModal$ | async"
        appDropdownPanel
      >
        <mat-icon
          *ngIf="(displayAsOpenedModal$ | async) === false"
          class="search-engine__icon"
          [class.search-engine__icon--focused]="(field | castToSpecificFieldType)?.panelIsOpen"
          matSuffix
          role="presentation"
          [svgIcon]="field.icon"
        ></mat-icon>

        <app-dropdown
          [formControlName]="field.name"
          [label]="field.placeholder"
          [ariaLabel]="field.ariaLabel"
          class="dropdown-contracts dropdown--filter"
          [multiple]="true"
          [options]="(field | castToSpecificFieldType)?.value"
          [required]="false"
          (panelTriggered)="updateDropdownPanelState(field, $event)"
          (panelTriggered)="toggleCanAdvancedFiltersClose($event)"
          [doubleColumn]="
            (isMobileOrTablet$ | async) === false ? (field | castToSpecificFieldType)?.doubleColumn : false
          "
          (valueUpdated)="fieldHasChanged(fields.liveSearch)"
          [advancedFilterSearchEngine]="true"
          [orderByAscd]="(field | castToSpecificFieldType)?.orderByAscd"
        ></app-dropdown>
      </div>
      <app-date-input-search
        *ngIf="field.type === SearchEngineFieldType.DateInput"
        [formControlName]="field.name"
        [field]="field | castToSpecificFieldType"
        (hasChanged)="fieldHasChanged(fields.liveSearch)"
        (isPanelOpen)="toggleCanAdvancedFiltersClose($event)"
      ></app-date-input-search>
      <div
        *ngIf="field.type === SearchEngineFieldType.JobsEuresInput"
        class="advanced-search-container__element"
        [class.search-engine__element--modal]="modalOpen$ | async"
        appDropdownPanel
      >
        <app-jobs-eures-input-search
          [formControlName]="field.name"
          [field]="field | castToSpecificFieldType"
          (hasChanged)="fieldHasChanged(fields.liveSearch)"
        >
        </app-jobs-eures-input-search>
      </div>
    </ng-container>
    <button
      *ngIf="(isMobileOrTablet$ | async) === false"
      type="button"
      class="advanced-search-container__close-btn delete-btn btn-clean"
      aria-label="Fermer les filtres avancés"
      (click)="closeAdvancedFilters()"
    >
      <mat-icon svgIcon="cross" role="presentation"></mat-icon>
    </button>
  </ng-container>
</ng-template>
